/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Currency } from './';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './';

/**
 * 
 * @export
 * @interface ClientCompanyPaymentPreferencesResource
 */
export interface ClientCompanyPaymentPreferencesResource {
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyPaymentPreferencesResource
     */
    legalEntityId: string;
    /**
     * 
     * @type {Currency}
     * @memberof ClientCompanyPaymentPreferencesResource
     */
    currencyCode: Currency;
}

/**
 * Check if a given object implements the ClientCompanyPaymentPreferencesResource interface.
 */
export function instanceOfClientCompanyPaymentPreferencesResource(value: object): value is ClientCompanyPaymentPreferencesResource {
    if (!('legalEntityId' in value) || value['legalEntityId'] === undefined) return false;
    if (!('currencyCode' in value) || value['currencyCode'] === undefined) return false;
    return true;
}

export function ClientCompanyPaymentPreferencesResourceFromJSON(json: any): ClientCompanyPaymentPreferencesResource {
    return ClientCompanyPaymentPreferencesResourceFromJSONTyped(json, false);
}

export function ClientCompanyPaymentPreferencesResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientCompanyPaymentPreferencesResource {
    if (json == null) {
        return json;
    }
    return {
        
        'legalEntityId': json['legalEntityId'],
        'currencyCode': CurrencyFromJSON(json['currencyCode']),
    };
}

export function ClientCompanyPaymentPreferencesResourceToJSON(value?: ClientCompanyPaymentPreferencesResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'legalEntityId': value['legalEntityId'],
        'currencyCode': CurrencyToJSON(value['currencyCode']),
    };
}

